import { Component, ComponentFactoryResolver, Inject, OnDestroy, OnInit, Type, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { BaseComponent, ConfirmComponent, Message, MessageService } from '@rubii/frontend-common';
import { DataSourceListData } from '@rubii/sdk-web-user/src/types/data-source-list-data.type';
import { DataSourceStatusList } from '@rubii/sdk-web-user/src/types/data-source-status-list.type';
import { ClientService } from '../../../services/client.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Second } from '@rubii/share/src/constants';

type DataSourceStatus = {
    email: string;
    identifier: string;
    status: string;
    lastModified: string;
    color: string;
};

@Component({
    selector: 'app-datasource-detail',
    templateUrl: './datasource-detail.component.html',
    styleUrls: ['./datasource-detail.component.scss']
})
export class DatasourceDetailComponent extends BaseComponent implements OnInit, OnDestroy {

    statusList: DataSourceStatus[] = [];
    timer: any;

    constructor(
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        private client: ClientService,
        @Inject(MAT_DIALOG_DATA) public data: { source: DataSourceListData }) {
        super();
        
    }

    updateStatusList(statusList: DataSourceStatus[]) {
        this.statusList = (statusList || []).map(status => {
            let color = '#505565';
            if (status.status.toLowerCase().includes('error')) {
                color = '#E54E44';
            } else if (status.status.toLowerCase().includes('finished')) {
                color = '#76D880'
            }
            return {...status, color};
        });
    }

    ngOnDestroy(): void {
        clearInterval(this.timer);
    }

    async ngOnInit() {
        this.updateStatusList(this.data.source.statusList?.statusList as DataSourceStatus[]);
        this.timer = setInterval(async () => {
            const statusList = await this.client.account.getEnabledDataSourceStatus([this.data.source.id]);
            if (statusList[this.data.source.id]) {
                this.updateStatusList(statusList[this.data.source.id].statusList as DataSourceStatus[]);
            }
        }, 2 * Second);
    }

    delete(status: DataSourceStatus) {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            data: {
                title: 'Delete Connection',
                subTitle: 'Are you sure to delete this connection?',
                okBtn: { name: 'Confirm', value: 'Confirm' },
                cancelBtn: { name: 'Cancel', value: 'Cancel' }
            }
        });

        dialogRef.afterClosed().subscribe((data) => {
            if (!data || data === 'Cancel') {
                return;
            }
            this.client.account.deleteEnabledDataSource({dspId: this.data.source.id, identifier: status.identifier}).then(res => {
                this.statusList = this.statusList.filter(s => s.identifier !== status.identifier);
                if (this.statusList.length === 0) {
                    this.dialog.closeAll();
                }
            }).catch(e => this.openSnackBarWarning(this.snackBar, 'Failed to delete the connection'));
        });
    }
}
